(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["collection-image-slider"] && !Shopify.designMode) return;
  try {
    
  if (!customElements.get('collection-image-slider')) {
    customElements.define('collection-image-slider', class CollectionImageSlider extends HTMLElement {
      connectedCallback() {
        this.carousel = this.querySelector('scroll-carousel');
        this.toggleButton = this.querySelector('[data-autoplay-toggle]');
        this.cycleSpeed = Number(this.getAttribute('autoplay')) * 1000;
        this.userPaused = window.matchMedia('(prefers-reduced-motion: reduce)').matches;
        this.interactionPaused = false;

        if (!this.carousel || !this.toggleButton || !this.cycleSpeed || this.carousel.cells.length < 2) return;

        this.abortController = new AbortController();
        const listenerOptions = { signal: this.abortController.signal };

        this.toggleButton.addEventListener('click', () => {
          this.userPaused = !this.userPaused;
          this.updatePlayer();
        }, listenerOptions);

        this.carousel.addEventListener('carousel:select', () => this.scheduleNext(), listenerOptions);
        document.addEventListener('visibilitychange', () => this.scheduleNext(), listenerOptions);

        if (this.hasAttribute('pause-on-hover')) {
          this.addEventListener('mouseenter', () => {
            this.interactionPaused = true;
            this.scheduleNext();
          }, listenerOptions);

          this.addEventListener('mouseleave', () => {
            this.interactionPaused = false;
            this.scheduleNext();
          }, listenerOptions);
        }

        this.addEventListener('focusin', () => {
          this.interactionPaused = true;
          this.scheduleNext();
        }, listenerOptions);

        this.addEventListener('focusout', (event) => {
          if (!this.contains(event.relatedTarget)) {
            this.interactionPaused = false;
            this.scheduleNext();
          }
        }, listenerOptions);

        this.updatePlayer();
      }

      disconnectedCallback() {
        clearTimeout(this.autoplayTimer);
        this.abortController?.abort();
      }

      updatePlayer() {
        const isPaused = this.userPaused;
        this.toggleButton.setAttribute('aria-pressed', String(isPaused));
        this.toggleButton.setAttribute('aria-label', isPaused ? 'Autoplay starten' : 'Autoplay pausieren');
        this.toggleButton.querySelector('[data-autoplay-pause]').hidden = isPaused;
        this.toggleButton.querySelector('[data-autoplay-play]').hidden = !isPaused;
        this.scheduleNext();
      }

      scheduleNext() {
        clearTimeout(this.autoplayTimer);

        if (this.userPaused || this.interactionPaused || document.hidden) return;

        this.autoplayTimer = setTimeout(() => {
          const nextIndex = (this.carousel.selectedIndex + 1) % this.carousel.cells.length;
          this.carousel.select(nextIndex);
        }, this.cycleSpeed);
      }
    });
  }

  } catch(e) { console.error(e); }
})();
})();
